import { render, staticRenderFns } from "./LawConsult.vue?vue&type=template&id=274d50fa&"
import script from "./LawConsult.vue?vue&type=script&lang=js&"
export * from "./LawConsult.vue?vue&type=script&lang=js&"
import style0 from "./LawConsult.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports